import { get, patch, post } from "../config/api/user";

export const Goal = {
  create: (props: {
    progressAmount: string;
    title?: string;
    maxAmount?: string;
  }) => post(`donation-goal`, props),
  getSelf: () =>
    get(`donation-goal/self`, {
      headers: {
        "Ignore-Interceptors": "true",
      },
    }),
  update: (props: any) => patch(`donation-goal/self`, props),
};
